import React, { useEffect, useState, useMemo } from 'react';
import s from './AccountTopUp.module.css';
import { Popover } from "antd";
import infoIcon from "../../../../assets/images/personalAccount/info.svg";
import CustomDropdownForAccounts from "../../../../components/ui/CustomDropdownForAccounts/CustomDropdownForAccounts";
import { useAppDispatch, useAppSelector } from "../../../../hooks/redux";
import { Formik, useFormikContext } from "formik";
import * as yup from "yup";
import { setFilters, setFiltersTemplates } from "../../../../store/reducers/TransactionsSlice/TransactionsSlice";
import { useSelector } from "react-redux";
import { selectAccountsByFilter, selectIsCentiWiseEnabledByAccount, selectTopUpByAccount } from "../../../../store/reducers/TransactionsSlice/selector";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import PersonalIban from "./PersonalIban/PersonalIban";
import CorrespondentAccount from "./CorrespondentAccount/CorrespondentAccount";
import { brandConfig } from '../../../../config/config';
// import TopUpByCard from './TopUpByCard/TopUpByCard';
import TopUpByBankOrMobile from './TopUpByBankOrMobile/TopUpByBankOrMobile';
import CustomModal from "../../../../components/ui/CustomModal/CustomModal";
import CustomDropdown from "../../../../components/ui/CustomDropdown/CustomDropdown";
import MyTextarea from "../../../../components/ui/MyTextarea/MyTextarea";
import MyBtn from "../../../../components/ui/MyBtn/MyBtn";
import TransparentButton from "../../../../components/ui/TransparentButton/TransparentButton";
import { getTicketListThunk, requestIbanTicketThunk } from "../../../../store/reducers/ActionCreators";

const AutoSubmitComponent = () => {
    const { values, submitForm } = useFormikContext();

    useEffect(() => {
        submitForm();
    }, [values, submitForm]);

    return null;
};

export const AccountTopUp = () => {
    const accountsList = useSelector(selectAccountsByFilter);
    const accountTopUpList = useSelector(selectTopUpByAccount);
    const isCentiwiseEnabled = useSelector(selectIsCentiWiseEnabledByAccount);
    const dispatch = useAppDispatch();
    const [tabIndex, setTabIndex] = useState(0);
    const token = useAppSelector(state => state.userReducer.user.userToken);

    // Helper function to get currency from account number
    const getAccountCurrency = (accountNumber: string) => {
        const account = accountsList.find((acc: any) => acc.number === accountNumber);
        return account?.currency || '';
    };

    // Helper function to check if currency supports IBAN requests
    const isCurrencySupported = (currency: string) => {
        const unsupportedCurrencies = ['USDT', 'USD-CARD', 'EUR-CARD'];
        return !unsupportedCurrencies.includes(currency);
    };

    // Helper function to get available payment methods based on currency
    const getAvailablePaymentMethods = (currency: string) => {
        const methods = [];
        
        // SEPA is only available for EUR
        if (currency === 'EUR') {
            methods.push('SEPA (only for EUR)');
        }
        
        // SWIFT is available for EUR, USD, GBP, CAD, AED
        const swiftSupportedCurrencies = ['EUR', 'USD', 'GBP', 'CAD', 'AED'];
        if (swiftSupportedCurrencies.includes(currency)) {
            methods.push('SWIFT (International Transfer)');
        }
        
        return methods;
    };

    const [isRequestIbanOpen, setIsRequestIbanOpen] = useState(false);
    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
    const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const modalValidationSchema = yup.object({
        paymentMethod: yup.string().required('Payment method is required'),
        description: yup.string()
    });
    const [isSubmittingTicket, setIsSubmittingTicket] = useState(false);
    const [tickets, setTickets] = useState<any[]>([]);

    useEffect(() => {
        // Check if main iber account exists (currently commented out but keeping variable for potential future use)
        // const hasMainIberAccount = accountTopUpList?.iber?.some((item:any) => item.isMain);
        
        // if (hasMainIberAccount && tabIndex !== 1) {
        //     setTabIndex(1);
        // }

        return () => {
            dispatch(setFiltersTemplates({
                accountNumber: '',
                period: null,
                from: '',
                to: '',
                purpose: '',
                recipient: '',
                amount: '',
                incoming: false,
                outgoing: false,
                currency: '',
                selectedType: '',
                templateName: '',
                paymentRegion: ''
            }));
        };
    }, [accountTopUpList, dispatch]);

    const renderedTabs = useMemo(() => (
        <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(() => index)}>
            <TabList className={s.tabstitle_block}>
                {accountTopUpList?.virtual?.length > 0 && (
                    <Tab selectedClassName={s.active_tab} className={s.tabtitle}>
                        Personal IBAN
                    </Tab>
                )}
                {accountTopUpList?.iber?.length > 0 && (
                    <Tab selectedClassName={s.active_tab} className={s.tabtitle}>
                        {brandConfig.companyNameSimple} Correspondent Account
                    </Tab>
                )}
                {isCentiwiseEnabled && (
                    <>
                        {/* <Tab selectedClassName={s.active_tab} className={s.tabtitle}>Top-Up by Card</Tab> */}
                        <Tab selectedClassName={s.active_tab} className={s.tabtitle}>Top-Up by Link</Tab>
                    </>
                 )} 
            </TabList>
            {accountTopUpList?.virtual?.length > 0 && (
                <TabPanel>
                    <PersonalIban list={accountTopUpList?.virtual} />
                </TabPanel>
            )}
            {accountTopUpList?.iber?.length > 0 && (
                <TabPanel>
                    <CorrespondentAccount list={accountTopUpList?.iber} />
                </TabPanel>
            )}
            {/* {isCentiwiseEnabled && ( */}
                {/* <TabPanel>
                    <TopUpByCard paymentMethod='1' />
                </TabPanel> */}
            {/* )} */}
            {isCentiwiseEnabled && (
                <TabPanel>
                    <TopUpByBankOrMobile paymentMethod='2' />
                </TabPanel>
            )} 
        </Tabs>
    ), [tabIndex, accountTopUpList, isCentiwiseEnabled]);

    return (
        <div className={s.accountTopUpWrapper}>
            <Formik initialValues={{ accountNumber: '' }}
                onSubmit={(values) => {
                    dispatch(setFilters({ accountNumber: values.accountNumber }));
                }}
            >
                {({
                    values,
                    handleChange,
                    handleSubmit
                }) => (
                    <form onSubmit={handleSubmit}>
                        <div className={s.detailsWrapper}>
                            <div className={s.detailsContent}>
                                <p className={s.detailsTitle}>Details for the Bank Transfer</p>
                                <div>
                                    <p className={s.labelText}>
                                        Payer account
                                        <Popover
                                            content={"Your internal account number."}
                                            color={'#EEEFEF'}
                                            placement={"bottom"}
                                            overlayInnerStyle={{
                                                fontFamily: 'Inter',
                                                padding: '13px 16px',
                                                backgroundColor: '#EEEFEF',
                                                boxShadow: 'none'
                                            }}
                                        >
                                            <img src={infoIcon} alt="" />
                                        </Popover>
                                    </p>
                                    <CustomDropdownForAccounts
                                        items={accountsList}
                                        id='accountNumber'
                                        name='accountNumber'
                                        placeholder={"Please select the account"}
                                    />
                                </div>

                                {
                                (accountTopUpList?.virtual?.length > 0 || accountTopUpList?.iber?.length > 0 || isCentiwiseEnabled) &&
                                    renderedTabs
                                }
                                {values.accountNumber && isCurrencySupported(getAccountCurrency(values.accountNumber)) && getAvailablePaymentMethods(getAccountCurrency(values.accountNumber)).length > 0 && (
                                    <div className={s.requestIbanBtnContainer}>
                                        <MyBtn
                                            title="IBAN / Account Number Request"
                                            medium
                                            onClick={() => setIsRequestIbanOpen(true)}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                        {values.accountNumber && (
                            <div className={s.ticketsSection}>
                                <div className={s.ticketsHeader}>
                                    <span className={s.detailsTitle}>Your Requests</span>
                                </div>
                                <TicketsTable
                                    accountNumber={values.accountNumber}
                                    token={token}
                                    tickets={tickets}
                                    setTickets={setTickets}
                                />
                            </div>
                        )}

                        <AutoSubmitComponent />

                        <CustomModal isModalOpen={isRequestIbanOpen} setIsModalOpen={setIsRequestIbanOpen}>
                            <Formik
                                initialValues={{
                                    paymentMethod: getAvailablePaymentMethods(getAccountCurrency(values.accountNumber))[0] || '',
                                    description: ''
                                }}
                                validationSchema={modalValidationSchema}
                                onSubmit={async (modalValues, { resetForm }) => {
                                    if (!values.accountNumber || !token) return;
                                    try {
                                        setIsSubmittingTicket(true);
                                        const composedDescription = `${modalValues.paymentMethod}  | Description: ${modalValues.description || ''}`;
                                        await dispatch(requestIbanTicketThunk(token, {
                                            accountNumber: values.accountNumber,
                                            description: composedDescription,
                                        }) as any);
                                        setIsRequestIbanOpen(false);
                                        resetForm();
                                        setIsSuccessModalOpen(true);
                                        const { data } = await dispatch(getTicketListThunk(token, { accountNumber: values.accountNumber }) as any);
                                        setTickets(filterDisplayableTickets(data));
                                    } catch (e: any) {
                                        setErrorMessage(e.response?.data?.message || e.message || 'Something went wrong. Please try again later.');
                                        setIsErrorModalOpen(true);
                                    } finally {
                                        setIsSubmittingTicket(false);
                                    }
                                }}
                            >
                                {({ errors: modalErrors, touched: modalTouched, handleSubmit: handleModalSubmit, handleChange: handleModalChange, values: modalValues }) => (
                                    <div>
                                        <div className={s.modalContent}>
                                            <div className={s.modalTitle}>
                                                IBAN / Account Number Request
                                            </div>
                                            <div className={s.modalField}>
                                                <span>Payment Method</span>
                                                <CustomDropdown
                                                    items={getAvailablePaymentMethods(getAccountCurrency(values.accountNumber))}
                                                    placeholder="Select payment method"
                                                    id="paymentMethod"
                                                    name="paymentMethod"
                                                    isError={modalErrors.paymentMethod}
                                                    touched={modalTouched.paymentMethod}
                                                />
                                                {modalErrors.paymentMethod && modalTouched.paymentMethod && (
                                                    <div className={s.error_message}>{modalErrors.paymentMethod}</div>
                                                )}
                                            </div>
                                            <div className={s.modalField}>
                                                <span>Description (Optional)</span>
                                                <MyTextarea
                                                    id="description"
                                                    name="description"
                                                    placeholder="Describe your request..."
                                                    value={modalValues.description}
                                                    onChange={handleModalChange}
                                                    style={{ height: 96, width: '100%' }}
                                                />
                                            </div>
                                        </div>
                                        <div className={s.modalActions}>
                                            <MyBtn
                                                title={isSubmittingTicket ? 'Submitting...' : 'Submit Request'}
                                                large
                                                style={{width: 180}}
                                                localDisable={isSubmittingTicket || !values.accountNumber}
                                                onClick={() => {
                                                    handleModalSubmit();
                                                }}
                                            />
                                            <TransparentButton
                                                title={'Cancel'}
                                                style={{width: 180}}
                                                large
                                                onClick={() => {
                                                    setIsRequestIbanOpen(false);
                                                }}
                                            />
                                        </div>
                                    </div>
                                )}
                            </Formik>
                        </CustomModal>

                        {/* Success Modal */}
                        <CustomModal setIsModalOpen={setIsSuccessModalOpen} isModalOpen={isSuccessModalOpen}>
                            <div>
                                <div className={s.popup_title}>Success!</div>
                                <div className={s.popup_subtitle}>
                                    Your IBAN / Account Number request has been submitted successfully.
                                </div>
                                <div className={s.popup_button_wrapper}>
                                    <div className={s.btn_block}>
                                        <MyBtn title={"Ok"} onClick={() => setIsSuccessModalOpen(false)} />
                                    </div>
                                </div>
                            </div>
                        </CustomModal>

                        {/* Error Modal */}
                        <CustomModal setIsModalOpen={setIsErrorModalOpen} isModalOpen={isErrorModalOpen} type={"error"}>
                            <div>
                                <div className={s.popup_title}>Oops!</div>
                                <div className={s.popup_subtitle}>
                                    {errorMessage}
                                </div>
                                <div className={s.popup_button_wrapper}>
                                    <div className={s.btn_block}>
                                        <MyBtn buttonType={"error"} title={"Ok"} onClick={() => setIsErrorModalOpen(false)} />
                                    </div>
                                </div>
                            </div>
                        </CustomModal>
                    </form>
                )}
            </Formik>
        </div>
    );
};

function filterDisplayableTickets(list: any[]): any[] {
    const allowed = new Set(['New', 'Processing', 'Rejected']);
    return Array.isArray(list) ? list.filter((t) => allowed.has(t.status)) : [];
}

type TicketsTableProps = {
    accountNumber: string;
    token: string;
    tickets: any[];
    setTickets: (v: any[]) => void;
};

const TicketsTable: React.FC<TicketsTableProps> = ({ accountNumber, token, tickets, setTickets }) => {
    const dispatch = useAppDispatch();
    useEffect(() => {
        let isMounted = true;
        const load = async () => {
            if (!token || !accountNumber) return;
            try {
                const { data } = await (dispatch(getTicketListThunk(token, { accountNumber }) as any));
                if (isMounted) setTickets(filterDisplayableTickets(data));
            } catch (e) {
                if (isMounted) setTickets([]);
            }
        };
        load();
        return () => { isMounted = false; };
    }, [accountNumber, token, setTickets, dispatch]);

    if (!tickets || tickets.length === 0) {
        return null;
    }

    return (
        <div className={s.ticketsTableWrapper}>
            <table className={s.ticketsTable}>
                <thead>
                    <tr>
                        <th>Account</th>
                        <th>Type</th>
                        <th>Status</th>
                        <th>Description</th>
                        <th>Rejection Reason</th>
                        <th>Created</th>
                    </tr>
                </thead>
                <tbody>
                    {tickets.map((t) => (
                        <tr key={t.id}>
                            <td>{t.account || '-'}</td>
                            <td>{t.type}</td>
                            <td className={
                                t.status === 'New' ? s.statusNew :
                                t.status === 'Processing' ? s.statusProcessing :
                                t.status === 'Rejected' ? s.statusRejected : ''
                            }>{t.status}</td>
                            <td>{t.description}</td>
                            <td>{t.status === 'Rejected' ? (t.rejectionReason || '-') : '-'}</td>
                            <td>{t.createdAt ? new Date(t.createdAt * 1000).toLocaleString() : '-'}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
